import { render, staticRenderFns } from "./ComplieAudio.vue?vue&type=template&id=5fa3ed63&scoped=true"
import script from "./ComplieAudio.vue?vue&type=script&lang=js"
export * from "./ComplieAudio.vue?vue&type=script&lang=js"
import style0 from "./ComplieAudio.vue?vue&type=style&index=0&id=5fa3ed63&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa3ed63",
  null
  
)

export default component.exports